var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "384px",
    height: "384px",
    viewBox: "0 0 384 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left",
    transform: "translate(0.000000, -0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192,384 C217.213867,384 242.180267,379.0336 265.476267,369.384533 C288.770133,359.735467 309.934933,345.5936 327.765333,327.765333 C345.5936,309.934933 359.735467,288.770133 369.384533,265.476267 C379.0336,242.180267 384,217.213867 384,192 C384,166.786133 379.0336,141.819307 369.384533,118.5248 C359.735467,95.2302933 345.5936,74.0644267 327.765333,56.23552 C309.934933,38.4066133 288.770133,24.2641067 265.476267,14.61504 C242.180267,4.96618667 217.213867,7.10542736e-15 192,7.10542736e-15 C141.0784,7.10542736e-15 92.24256,20.22848 56.23552,56.23552 C20.22848,92.24256 1.42108547e-14,141.0784 1.42108547e-14,192 C1.42108547e-14,242.920533 20.22848,291.7568 56.23552,327.765333 C92.24256,363.771733 141.0784,384 192,384 Z M228.416,143.082667 C232.302933,139.0592 234.453333,133.6704 234.405088,128.0768 C234.3552,122.4832 232.110933,117.132587 228.155733,113.177173 C224.200533,109.22176 218.850133,106.978133 213.256533,106.928899 C207.662933,106.881067 202.274133,109.031253 198.250667,112.917333 L134.250667,176.917333 C130.251307,180.917333 128.00448,186.3424 128.00448,192 C128.00448,197.6576 130.251307,203.082667 134.250667,207.082667 L198.250667,271.082667 C202.274133,274.9696 207.662933,277.12 213.256533,277.071755 C218.850133,277.021867 224.200533,274.7776 228.155733,270.8224 C232.110933,266.8672 234.3552,261.5168 234.405088,255.9232 C234.453333,250.3296 232.302933,244.9408 228.416,240.917333 L179.498667,192 L228.416,143.082667 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.a797f1d2017b2c1461116378fcd8f7d4.svg";
export { ForwardRef as ReactComponent };